'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.initializeI18n = initializeI18n;

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = require('i18next-xhr-backend');

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _i18nextBrowserLanguagedetector = require('i18next-browser-languagedetector');

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('moment/locale/ru');

var _reactI18next = require('react-i18next');

var _domain = require('./domain');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializeI18n(application) {
    var settings = application.settings.get('i18n', {});

    var localSettings = _extends({
        fallbackLng: 'en',

        // have a common namespace used around the full app
        ns: ['common', 'validator'],
        defaultNS: 'common',

        debug: true
    }, settings, {

        interpolation: _extends({
            escapeValue: false, // not needed for react!!

            format: function format(value, formatting) {
                if (value instanceof Date) {
                    return (0, _moment2.default)(value).format(formatting);
                }
                return value;
            }
        }, settings.interpolation),
        // option for Language detector
        detection: _extends({
            // order and from where user language should be detected
            order: ['localStorage', 'navigator'],
            // keys or params to lookup language from
            lookupLocalStorage: 'i18nextLng',
            // cache user language on
            caches: ['cookie'],
            // domain for set cookie,
            cookieDomain: (0, _domain.getCookieDomain)(document.location.host)
        }, settings.detection),
        react: {
            useSuspense: true
        },
        initImmediate: true
    });

    var momentMap = localSettings.momentMap;


    _i18next2.default.on('languageChanged', function (lng) {
        if (momentMap && momentMap[lng]) {
            lng = momentMap[lng];
        }
        _moment2.default.locale(lng);
    });

    application.i18n = _i18next2.default.use(_i18nextXhrBackend2.default).use(_i18nextBrowserLanguagedetector2.default).use(_reactI18next.initReactI18next).init(localSettings);

    if (application.raven) {
        _i18next2.default.on('missingKey', function (langs, namespace, key) {
            application.raven.captureMessage('i18next missing key: "' + key + '" in namespace: "' + namespace + '"');
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/I18n.js
// module id = 1301
// module chunks = 118